<template>
  <div>
    <v-card class="rounded-lg" elevation="0" color="#41916b">
      <v-card-title class="text-center justify-center py-2">
        <h5 class="font-weight-bold" style="color: white">
          {{ $t('titles.family_approve') }} - Paciente {{ patientData.name }}
        </h5>
      </v-card-title>
      <v-tabs v-model="tab" fixed-tabs background-color="#41916b" dark>
        <v-tabs-slider color="#b1e3cc"></v-tabs-slider>
        <v-tab>{{ $t('titles.family_interview') }}</v-tab>
        <v-tab>{{ $t('titles.family_allow') }}</v-tab>

        <v-tab-item>
          <FamilyInterview :patientData="patientData" @changeTab="handleChangeTab" />
        </v-tab-item>
        <v-tab-item>
          <v-card-text>
            <v-form @submit.prevent="saveFamilyAuthorization" ref="form" :disabled="disableForm">
              <v-container style="
                  border: solid 1px #e1e3e2;
                  border-radius: 15px;
                  padding: 15px;
                ">
                <v-row dense>
                  <v-col class="d-flex" cols="12" sm="3">
                    <v-radio-group v-model="family_authorization" :rules="formRules">
                      <p>
                        {{ $t('inputs.family_authorization.family_allow_question') }}<span style="color: red">*</span>
                      </p>

                      <v-radio :label="$t('options.yes')" value="1" color="#086318"></v-radio>

                      <v-radio :label="$t('options.not')" value="2" color="#086318"></v-radio>
                    </v-radio-group>
                  </v-col>
                  <v-col class="d-flex" cols="12" :sm="resource.reason_not_donation == 'OUTROS' ? '4' : '8'"
                    v-if="family_authorization == '2'">
                    <v-autocomplete :items="familiarOptions" item-text="description" item-value="description"
                      variant="outlined" :rules="formRules" color="#086318" v-model="resource.reason_not_donation">
                      <template v-slot:label>
                        {{ $t('descriptions.choose_a_reason') }} <span style="color: red">*</span>
                      </template>
                    </v-autocomplete>
                  </v-col>
                  <v-col class="d-flex" cols="12" sm="5" v-if="resource.reason_not_donation == 'OUTROS'">
                    <v-textarea :rules="formRules" rows="1" color="#086318" v-model="resource.justification">
                      <template v-slot:label>
                        {{ $t('inputs.family_authorization.describe_reason') }} <span style="color: red">*</span>
                      </template>
                    </v-textarea>
                  </v-col>
                </v-row>

                <v-row dense v-if="family_authorization == '1'">
                  <v-col class="d-flex" cols="12" sm="5">
                    <v-text-field :rules="formRules" color="#086318" v-model="resource.responsible_for_the_interview">
                      <template v-slot:label>
                        {{ $t('inputs.family_authorization.interview_responsible') }}
                        <span style="color: red">*</span>
                      </template>
                    </v-text-field>
                  </v-col>
                  <v-col class="d-flex" cols="12" sm="3">
                    <v-text-field v-model="resource.authorization_date_and_time" type="datetime-local"
                      @input="onDateTimeInput('authorization_date_and_time', $event)" :max="maxDateTime"
                      :rules="dateRules" persistent-hint color="#086318">
                      <template v-slot:label>
                        {{ $t('inputs.family_authorization.interview_datetime') }}
                        <span style="color: red">*</span>
                      </template>
                    </v-text-field>
                  </v-col>
                </v-row>

                <v-row dense class="form-actions">
                  <v-btn
                    class="rounded-lg form-action-btn"
                    elevation="0"
                    color="#41916b"
                    type="submit"
                    v-if="disableSaveButton == false"
                  >
                    <span class="textBtn">{{ saveBTN }}</span>
                  </v-btn>

                  <v-btn
                    class="form-edit-btn"
                    v-if="disableEditButton"
                    color="#41916b"
                    fab
                    small
                    dark
                    @click="(disableForm = false), (disableSaveButton = false)"
                  >
                    <v-icon>mdi-pencil</v-icon>
                  </v-btn>

                  <BackToGridBtn />
                </v-row>
              </v-container>
            </v-form>
          </v-card-text>
        </v-tab-item>
      </v-tabs>
    </v-card>
  </div>
</template>

<script>
import axios from "@/axios";
import { mapGetters, mapActions } from "vuex";
import dateTimeLimit from "@/utils/dateTimeLimit";
import Formatters from "@/utils/Formatters";
import FamilyInterview from "./FamilyInterview.vue";
import BackToGridBtn from "@/components/widgets/BackToGridBtn";
export default {
  data() {
    return {
      tab: 0,
      resource: {},
      formRules: [(v) => !!v || this.$t('messages.required_field')],
      dateRules: [
        v => !!v || this.$t('messages.required_field'),
        v => {
          if (!v) return true

          const inputDate = new Date(v)
          const now = new Date()

          if (inputDate > now)
            return this.$t('messages.future_date_not_allowed')

          return true
        }
      ],
      family_authorization: "",
      familiarOptions: [],
      disableForm: false,
      disableSaveButton: false,
      disableEditButton: false,
    };
  },

  computed: {
    ...mapGetters({
      patientData: "getPatientData",
      donorId: "getDonorId",
    }),

    saveBTN() {
      return this.resource.id ? this.$t('buttons.to_update') : this.$t('buttons.save')
    },

    maxDateTime() {
      const now = new Date()
      return now.toISOString().slice(0, 16)
    }
  },

  components: {
    FamilyInterview,
    BackToGridBtn
  }, 

  watch: {
    patientData: {
      handler(data) {
        this.initializeFamilyAuthorization(data);
      },
      immediate: true,
    },
  },
 
  methods: {
    ...mapActions(["changeSnackBarData", "changePatientData"]),

    initializeFamilyAuthorization(data) {
      const familyAuthorization = data?.family_authorization;
      const statusId = familyAuthorization?.authorization_status_id;

      if (!statusId) return;

      this.checkFamilyAuthorization(statusId, data);
    },

    checkFamilyAuthorization(status, item) {
      if (status == '1') {
        this.hasAuthorization(item);
        return;
      }
      this.hasNotAuthorization(item);
    },

    hasAuthorization(item) { 
      this.disableForm = true;
      this.resource = item.family_authorization;
      this.family_authorization = "1";
      this.disableSaveButton = true;
      this.disableEditButton = true;
    },

    hasNotAuthorization(item) {
      const family_authorization = item.family_authorization;

      this.disableForm = true;
      this.disableSaveButton = true;
      this.disableEditButton = true;

      const option = family_authorization.family_authorization_options[0].authorization_option_id
      this.family_authorization = "2";

      const found = this.familiarOptions.find((x) => x.id == option)
      this.$set(this.resource, 'reason_not_donation', found ? found.description : null)

      if (family_authorization.family_authorization_options[0].authorization_option.description == 'OUTROS'
        && family_authorization.justification) {
        this.$set(this.resource, 'justification', family_authorization.justification)
      }
    },

    onDateTimeInput(field, value) {
      this.resource[field] =
        dateTimeLimit.limitYearField(value)
    },

    saveFamilyAuthorization() {
      if (!this.$refs.form.validate()) return;

      this.prepareResource();
      const data = this.buildAuthorizationData();
      const family_authorization_id = this.patientData.family_authorization ? this.patientData.family_authorization.id : null;

      axios({
        method: family_authorization_id ? "PUT" : "POST",
        url: family_authorization_id
          ? `/family_authorization/${family_authorization_id}`
          : `/family_authorization/create`,
        data,
      }).then(this.handleAuthorizationSuccess)
        .catch(this.handleAuthorizationError);
    },

    prepareResource() { 
      this.resource.authorization_status_id = this.family_authorization == 2 ? 2 : 1;
      this.resource.donor_id = this.donorId ? this.donorId : this.patientData.id;
      this.resource.justification = this.resource.justification || null;

      if (this.family_authorization == 2) {
        this.resource.reason_not_donation_id =
          this.familiarOptions.find((x) => x.description == this.resource.reason_not_donation).id ?? null;
      }
    },

    buildAuthorizationData() { 
      const isEdit = !!this.resource.id;
      const hasAuthorization = this.family_authorization == '1';

      const data = {
        donor_id: this.resource.donor_id,
        authorization_status_id: this.resource.authorization_status_id,
        authorization_option_id: this.resource.authorization_status_id == 2 ? this.resource.reason_not_donation_id : null,
        responsible_for_the_interview: this.resource.authorization_status_id == 2 ? null : this.resource.responsible_for_the_interview,
        justification: this.resource.justification && this.resource.authorization_status_id == 2 ? this.resource.justification : null,
      };

      if (hasAuthorization) {
        data.authorization_date_and_time = this.formatDateTimeToBackend(this.resource.authorization_date_and_time);
      } else if (isEdit) {
        data.authorization_date_and_time = null;
      }

      return data;
    },

    handleAuthorizationSuccess(response) {
      this.changeSnackBarData({
        status: true,
        type: "success",
        titleMessage: response.data.message,
        bodyMessage: "",
        cardColor: "success",
        titleIcon: "mdi-check-circle",
      });

      setTimeout(() => {
        this.closeSnackBar();
        this.changePatientData({
          ...this.patientData,
          id: this.donorId ? this.donorId : this.patientData.id,
          name: this.patientData.name,
          kind_of_donor_id: this.patientData.kind_of_donor_id,
          kind_of_donor: this.patientData.kind_of_donor_id == 1 ? "ME" : "PCR",
          donor_status: {
            slug: this.resource.authorization_status_id == 2 ? 'doacao-nao-aut' : 'doacao-aut',
          },
        });
        this.$router.push(this.resource.authorization_status_id == 1 ? "/anexos" : "/pacientes");
      }, 2000);
    },

    handleAuthorizationError(err) {
      this.messageError = Formatters.formatErrorMessage(err);
      this.message = null;
      this.changeSnackBarData({
        status: true,
        type: "erro",
        titleMessage: this.$t('messages.something_went_wrong'),
        bodyMessage: this.messageError,
        cardColor: "red",
        titleIcon: "mdi-close-circle",
      });
      setTimeout(() => this.closeSnackBar(), 3000);
    },

    formatDateTimeToBackend(value) {
      if (!value) return null;
      return value
        .replace("T", " ")
        .substring(0, 16);
    },

    closeSnackBar() {
      this.changeSnackBarData({
        status: false,
        type: "",
        titleMessage: "",
        bodyMessage: "",
        cardColor: "",
        titleIcon: "",
      });
    },

    getReasons() {
      const kindPatientId = this.patientData.kind_of_donor_id
      const familyReasons = 1

      axios.get(`/authorization_options/reason_not_donation_id/${familyReasons}`, {
        params: {
          kind_of_donor_id: kindPatientId,
        }
      }).then((response) => { 
        this.familiarOptions = response.data.data ?? response.data;

        if (this.patientData.family_authorization) { 
          if(this.patientData.family_authorization.authorization_status_id == '2'){
            this.hasNotAuthorization(this.patientData);
          } 
        }
      });
    },

    handleChangeTab(tab) {
      this.tab = tab;
    },
  },

  mounted() {
    this.getReasons(); 
  },
};
</script>

<style scoped>
p {
  font-size: 16px;
}

.form-actions {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 24px;
}

.form-action-btn,
.form-edit-btn {
  margin-right: 8px;
}

.form-action-btn:last-child,
.form-edit-btn:last-child {
  margin-right: 0;
}

.textBtn {
  color: #fff;
}

@media (max-width: 768px) {
  .form-actions {
    flex-direction: column;
    align-items: stretch;
  }

  .form-action-btn,
  .form-edit-btn {
    width: 100%;
    margin-right: 0;
    margin-bottom: 8px;
  }

  .form-edit-btn {
    border-radius: 8px !important;
  }

  .form-action-btn:last-child,
  .form-edit-btn:last-child {
    margin-bottom: 0;
  }
}
</style>
